import React, { Fragment, useContext, useEffect } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import HeaderComponent from "../../components/header/header.component";
import { GlobalContext } from "../../store";
import LandscapedContent from "../../modules/landscape/components/landscape-content/landscape-content.component";
import PagesHeadComponent from "../../components/pages-head-component/pages-head.component";
import { ContentLayout } from "../../layouts/content/content.layout";
import SupportBlockComponent from "../../components/support/support.component";

export default function LandscapePage() {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.AI_RISK_LANDSCAPE"));
      setPageTitle(t("PAGE_META_TITLES.AI_RISK_LANDSCAPE"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.AI_RISK_LANDSCAPE_TITLE")}
          subTitle={t("PAGES_HEAD.AI_RISK_LANDSCAPE_SUB_TITLE")}
        />
        <LandscapedContent />
        <SupportBlockComponent />
      </ContentLayout>
    </Fragment>
  );
}
